module.exports = {
      id: "information--marker-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#information--marker-usage",
      toString: function () {
        return this.url;
      }
    }